import { useAppSelector } from "@builder/store/store";
import "./style.scss";

const ErrorPopup = () => {
    const error = useAppSelector(state => state.builder.error);

    if (error) {
        return (
            <div className="error-popup-wrapper">
                <div className="error-popup">
                    <p className="type1">Something went wrong</p>
                    <span>
                        <p>Error message:</p>
                        <p>{error}</p>
                    </span>
                    <p className="type2">
                        If you would like some assitance contact us <a href="">here</a>
                    </p>
                    <button onClick={() => (window.location.href = import.meta.env.VITE_HUB_URL)}>Back to hub</button>
                </div>
            </div>
        );
    }

    return null;
};

export default ErrorPopup;
